import { computed } from '@angular/core';
import {
    signalStore,
    withState,
    withComputed,
    withMethods,
    patchState,
} from '@ngrx/signals';
import { BundleGroup } from 'api/addons-v3/models';

/**
 * Bundle group (Mappengruppe) enriched with the organization site key that
 * provides access to it, analogous to FolderData / TourData.
 */
export interface BundleGroupData extends BundleGroup {
    orgSiteKey: string;
    read_only?: boolean;
}

export interface BundleGroupsState {
    bundleGroups: BundleGroupData[];
    loading: boolean;
    error: string | null;
    lastUpdated: number;
}

const initialState: BundleGroupsState = {
    bundleGroups: [],
    loading: false,
    error: null,
    lastUpdated: 0,
};

export const BundleGroupsStore = signalStore(
    { providedIn: 'root' },
    withState<BundleGroupsState>(initialState),
    withComputed(({ bundleGroups }) => ({
        bundleGroupsCount: computed(() => bundleGroups().length),
    })),
    withMethods(store => ({
        setBundleGroupsLoading(loading: boolean): void {
            patchState(store, { loading });
        },
        setBundleGroupsError(error: string | null): void {
            patchState(store, { error });
        },
        setBundleGroups(bundleGroups: BundleGroupData[]): void {
            patchState(store, { bundleGroups, lastUpdated: Date.now() });
        },
        removeBundleGroup(groupKey: string): void {
            patchState(store, state => ({
                bundleGroups: state.bundleGroups.filter(
                    group => group._key !== groupKey
                ),
                lastUpdated: Date.now(),
            }));
        },
        clearBundleGroups(): void {
            patchState(store, { bundleGroups: [], lastUpdated: Date.now() });
        },
    }))
);
